import React, { useEffect, useRef, useState } from 'react';
import { BwjEventArgs } from '../../../../framework/entities/bwj-event';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { ProductDetailPanel } from '../product-detail-panel';
import { IStormDoorHandleModel, StormDoorHandleModel } from '../../../../entities-generated/models/storm-door/storm-door-handle-model';

export interface IStormHandleDetailPanelArgs {
  handle: IStormDoorHandleModel;
  selected: IProductTexture | null;
}

interface IStormHandleDetailPanelProps {
  launchPanel: BwjEventArgs<IStormHandleDetailPanelArgs> | undefined;
  onHandleSelected: (handle: IStormDoorHandleModel, variant: IProductTexture) => void;
}

export const StormHandleDetailPanel: React.FunctionComponent<IStormHandleDetailPanelProps> = (props) => {
  const [showPanel, setShowPanel] = useState(false);
  const handleInfo = useRef<IStormHandleDetailPanelArgs>({ handle: new StormDoorHandleModel(), selected: null });
  const { launchPanel } = props;
  const initialVariantSelection = useRef<BwjEventArgs<IProductTexture | null>>(new BwjEventArgs(null));

  useEffect(() => {
    if(!launchPanel || launchPanel.inaccessible()) { return; }

    handleInfo.current = launchPanel.getArgs();
    initialVariantSelection.current = new BwjEventArgs(handleInfo.current.selected);
    setShowPanel(true);
  }, [launchPanel]);

  const onProductChosen = (variant: IProductTexture) => {
    props.onHandleSelected(handleInfo.current.handle, variant);
    onClosePanel();
  }

  const onClosePanel = () => {
    setShowPanel(false);
  }

  const h = handleInfo.current.handle;
  return (
    <ProductDetailPanel
      id={h.id}
      brand={h.brand}
      title={h.description}
      price={0}
      keyFeatures={h.sellingPoints}
      imageUrls={[h.imageUrl, ...h.auxImageUrls]}
      variants={h.textureVariants}
      variantDescriptor={'finish'}
      initialVariantSelection={initialVariantSelection.current}
      recommendation={h.recommendation}
      chooseProductButtonText={'Use this handle'}
      onProductChosen={onProductChosen}
      chooseVariantButtonText={'Choose finish'}
      showPanel={showPanel}
      onClosePanel={onClosePanel}
      onIncludedServicesOverlayRequested={() => {}}
      onSeeInPersonRequested={undefined}
    />
  );
};
